import React, { useContext, useState } from 'react';
import { AccountContext } from '../AccountContext';
import { toCurrency } from '@app/utilities';
import { useAsyncEffect } from '@app/hooks';
import { toast } from 'react-toastify';

export default function AccountRates({ refreshToken }: { refreshToken?: number }) {
  const { accountId, interestService } = useContext(AccountContext);
  const [accountInterestRates, setAccountInterestRates] = useState({} as any);
  const [retryCounter, setRetryCounter] = useState(0);
  const updateAccountInterestRates = async () => {
    setRetryCounter(retryCounter + 1);
    try {
      setRetryCounter(0);
      const accountInterestRates = await interestService.getAccountInterestRates(accountId);
      const rates = accountInterestRates.rates;
      const illustration = accountInterestRates.illustration;
      setAccountInterestRates({ loaded: true, rates, illustration });
    } catch (ex) {
      if (retryCounter < 3) {
        await updateAccountInterestRates();
      } else {
        toast.error('Update account interest rate failed.');
      }
    }
  };
  //
  useAsyncEffect(async () => {
    await updateAccountInterestRates();
  }, [accountId, refreshToken]);

  return (
    <>
      {accountInterestRates.loaded ? (
        accountInterestRates.rates.map((rate) => (
          <div key={rate.qualifications.SubledgerType ? rate.qualifications.SubledgerType : rate.qualifications.SpendType + rate.qualifications.FeeCategory} className="ui card">
            <div className="custom-card-header content">Current Account { rate.qualifications.SubledgerType ? rate.qualifications.SubledgerType : rate.qualifications.SpendType} Rate</div>
            <div className="content">
              {rate.qualifications.SubledgerType && (
                <div style={{ 'margin-bottom': '10px' }}>Subledger Type: {rate.qualifications.SubledgerType}</div>
              )}
              {rate.qualifications.SpendType && (
                <div style={{ 'margin-bottom': '10px' }}>Spend Type: {rate.qualifications.SpendType}</div>
              )}
              {rate.qualifications.FeeCategory && (
                <div style={{ 'margin-bottom': '10px' }}>Fee Category: {rate.qualifications.FeeCategory}</div>
              )}
              <div style={{ 'font-weight': 'bold' }}>Go To Rate</div>
              <div>Annual: {rate.values[0].derivedGoToRate.air}</div>
              <div>Monthly: {rate.values[0].derivedGoToRate.mir}</div>
              <div>Per Annum Variable: {rate.values[0].derivedGoToRate.pa}</div>
              {accountInterestRates.illustration &&
                rate.qualifications.SpendType == 'Purchase' &&
                rate.qualifications.FeeCategory == null && (
                  <div style={{ 'font-weight': 'bold', 'margin-top': '10px' }}>Illustrative Rates</div>
                )}
              {accountInterestRates.illustration &&
                rate.qualifications.SpendType == 'Purchase' &&
                rate.qualifications.FeeCategory == null && <div>APR: {accountInterestRates.illustration.apr}</div>}
              {accountInterestRates.illustration &&
                rate.qualifications.SpendType == 'Purchase' &&
                rate.qualifications.FeeCategory == null && (
                  <div>TCC: {toCurrency(accountInterestRates.illustration.tcc.value)}</div>
                )}
              {rate.values[0].temporaryRate != null && (
                <div style={{ 'font-weight': 'bold', 'margin-top': '10px' }}>Temporary Rate</div>
              )}
              {rate.values[0].temporaryRate != null && <div>Annual: {rate.values[0].derivedTemporaryRate.air}</div>}
              {rate.values[0].temporaryRate != null && <div>Monthly: {rate.values[0].derivedTemporaryRate.mir}</div>}
              {rate.values[0].temporaryRate != null && (
                <div>Per Annum Variable: {rate.values[0].derivedTemporaryRate.pa}</div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="ui active centered inline loader" />
      )}
    </>
  );
}
